import { Question } from "./voyage-assesment.models";

export const VOYAGE_ASSESMENT_QUESTIONS: Question[] = [
  {
    id: "flexibility",
    title: "Flexibility",
    subtitle: "How flexible was the response to changes or adjustments in CP Terms?",
  },
  {
    id: "promptnessAndCoorperation",
    title: "Promptness and coorperation",
    subtitle: "How prompt and effective was the response to requests and collaboration?",
  },
  {
    id: "transparencyAndComunication",
    title: "Transparency and comunication",
    subtitle: "How clear and open was the communication regarding relevant information and updates?",
  },
  {
    id: "crew",
    title: "Crew",
    subtitle: "How would you rate the crew quality, efficiency and working safety?",
  },
  {
    id: "fleetMaintenance",
    title: "Fleet maintenance",
    subtitle:
      "How would you rate the condition and maintenance standards of the vessel, including holds, cranes, grabs, lashing materials, and overall performance?",
  },
];
